import { render, staticRenderFns } from "./DashboardInfoBlocks.vue?vue&type=template&id=6b22a5d1&"
import script from "./DashboardInfoBlocks.vue?vue&type=script&lang=js&"
export * from "./DashboardInfoBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports